import React from 'react';
import { Trans, useLingui } from '@lingui/react';
import { BannerReturnCustomer, CarleadDataLayerManufacturerActive, useCarleadConfiguration } from '@wkda/carlead-creation-components';
import { ABExperimentSnippet, Layout } from '@wkda/funnel-components';
import { Helmet } from 'react-helmet';
import { CarleadCollapseButtonFaq, CarleadHowItWorks, CarleadTextButton, CarleadWhyChoose, HeadineText } from '../../../../components';
import { i18n as _i18n } from "@lingui/core";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CarleadBannerTextHIWWhyChooseWkdaFaq = _ref => {
  let {
    form,
    howItWorksShowCta = false
  } = _ref;
  const {
    abExperiment
  } = useCarleadConfiguration();
  const {
    i18n
  } = useLingui();
  const ambassadorTitle = i18n._('carlead.ambassadorBanner.title');
  const ambassadorName = i18n._('carlead.ambassadorBanner.name');
  const ambassadorQuote = [/*#__PURE__*/_jsx(Trans, {
    id: "carlead.ambassadorBanner.quote",
    components: [/*#__PURE__*/_jsx("strong", {})]
  })];
  return /*#__PURE__*/_jsxs(Layout, {
    customBanner: BannerReturnCustomer,
    containerClassName: "carlead-redesign",
    modernLayout: true,
    children: [/*#__PURE__*/_jsx(Helmet, {
      children: /*#__PURE__*/_jsx("title", {
        children: i18n._('carlead.pageTitle')
      })
    }), /*#__PURE__*/_jsx(CarleadDataLayerManufacturerActive, {}), /*#__PURE__*/_jsx(ABExperimentSnippet, {
      experimentSnippetName: abExperiment.experimentSnippetName
    }), /*#__PURE__*/_jsxs("div", {
      "data-category": "Lead Page",
      children: [form, /*#__PURE__*/_jsx("div", {
        className: "ambassador-banner-tony-rickardsson",
        children: /*#__PURE__*/_jsx(HeadineText, {
          title: ambassadorTitle,
          text: [ambassadorQuote, ambassadorName],
          className: "ambassador-banner-tony-rickardsson__wrapper"
        })
      }), /*#__PURE__*/_jsx(CarleadHowItWorks, {
        showCTA: howItWorksShowCta
      }), /*#__PURE__*/_jsx(CarleadWhyChoose, {}), /*#__PURE__*/_jsx(CarleadCollapseButtonFaq, {}), /*#__PURE__*/_jsx(CarleadTextButton, {
        text: _i18n._(
        /*i18n*/
        {
          id: 'carlead.textButton.text'
        })
      })]
    })]
  });
};
export default CarleadBannerTextHIWWhyChooseWkdaFaq;